import {
  CommonEventDetailId,
  VolleyballEventDetailId,
} from '@collector/sportsapi-client-legacy'

import { EventInfoControls } from '../../configuration'

export const eventInfoControls: EventInfoControls = [
  {
    control: {
      eventDetailId: VolleyballEventDetailId.SetsNumber,
    },
  },
  {
    grid: {
      cols: '3',
      class: 'gap-x-4',
      controls: [
        {
          eventDetailId: VolleyballEventDetailId.ScoringSystem,
          maxlength: 3,
        },
        {
          eventDetailId: VolleyballEventDetailId.PossibleGoldenSet,
          wide: true,
        },
        'TeamColorsSwitch',
        'empty',
        {
          eventDetailId: CommonEventDetailId.HasLineups,
          wide: true,
        },

        'AssignPlayerOnPitchSwitch',
      ],
    },
  },
]
